export default "__VITE_ASSET__h4BRM5xA__"